import { QueryCombinerType } from 'module/api/filter/types';
import { CenterAlignedBox } from 'module/ui/components/atoms/layout/layout';
import { Select } from 'module/ui/components/atoms/select';
import { Short01 } from 'module/ui/components/styles';
import { FC, useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

export interface Props {
  visible?: boolean;
  value: QueryCombinerType;
  readonly?: boolean;
  onChange?: (value: QueryCombinerType) => void;
}

const Label = styled.div`
  ${Short01};
  opacity: 0.5;
`;
const Wrapper = styled(CenterAlignedBox)`
  display: inline-flex;
  height: 32px;
  ${Label} {
    padding: 0 var(--spacing-03) 0 0;
  }

  .filter-drawer-select {
    .ozone-select__indicators {
      .ozone-select__indicator-separator {
        display: none;
      }
    }
  }
`;

export const CombinerTypeSelect: FC<Props> = ({
  value,
  readonly,
  onChange,
  visible,
}) => {
  const options = useMemo(() => {
    return [QueryCombinerType.All, QueryCombinerType.Any].map((type) => ({
      label: <FormattedMessage id={`filters.combiner.${type}`} />,
      value: type,
    }));
  }, []);
  const selectedOption = useMemo(() => {
    return options.find((option) => option.value === value);
  }, [options, value]);
  const onCombinerTypeChange = useCallback(
    (option) => {
      onChange?.(option.value);
    },
    [onChange],
  );

  if (visible === false) {
    return null;
  }

  return (
    <Wrapper>
      <Label>
        <FormattedMessage id="filters.combiner.title" />
      </Label>
      <Select
        isDisabled={readonly}
        value={selectedOption}
        options={options}
        onChange={onCombinerTypeChange}
        isSearchable={false}
      />
    </Wrapper>
  );
};
